import * as React from 'react';
import ReactDOM from 'react-dom';

import {TasksPage} from './tasks-page';

export function PortalledTasksSettings() {
    const tasksSettingsContainer = document.querySelector('#react-mount-tasks-page');
    if (tasksSettingsContainer) {
        return ReactDOM.createPortal(<TasksPage />, tasksSettingsContainer);
    }

    return null;
}
